// extracted by mini-css-extract-plugin
module.exports = {"md":"panelmenu-navbar-button_md_3zw1s","ios":"panelmenu-navbar-button_ios_6BWq7","button":"panelmenu-navbar-button_button_3e5Nz"};